<template>
  <div class="flex min-w-[250px] flex-col gap-2">
    <Button
      v-for="(service, key) in props.services"
      :key="key"
      class="!h-11 w-full items-center"
      type="button"
      :variant="ButtonVariant.Tertiary"
      text-left
      :active="selectedService == key"
      :data-service-key="service.service_code || service.carrier_key"
      @click="selectService(service, key)"
    >
      <div class="flex w-full">
        <p>{{ service.label }}</p>
      </div>
      <template #suffix>
        <Icon v-if="isSelected(service) && !IsDirty(service)" class="absolute top-3.5 right-3" src="check" />
        <Icon v-if="IsDirty(service)" class="absolute top-3.5 right-3" src="exclamation_mark" />
      </template>
    </Button>
  </div>
</template>

<script setup lang="ts">
  const props = defineProps<{
    services: any;
    selectedServices: Array<string>;
    dirtyServices: Array<string>;
  }>();

  const emit = defineEmits(["valueChange"]);

  const setService = ref(null);

  const selectedService = computed(() => {
    return setService.value ? setService.value : Object.keys(props.services)[0];
  });

  const isSelected = (service) => {
    return props.selectedServices.includes(returnKey(service));
  };

  const IsDirty = (service) => {
    return props.dirtyServices.includes(returnKey(service));
  };

  const returnKey = (service: object) => {
    return service.carrier_key == "service_codes" ? service.fields.key : service.carrier_key;
  };

  const selectService = (service, key) => {
    setService.value = key;
    emit("valueChange", service);
  };
</script>
